// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Manulife JH Sans", Helvetica, Arial, sans-serif;
}
.PhoneInputCountry {
  padding: 10px;
  padding-left: 0px;
}
.PhoneInputInput {
  font-size: 1rem;
  position: relative;
  font-weight: 300;
  line-height: 3rem;
  color: rgb(52, 56, 75);
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  border: none;
  height: 3rem;
  text-align: left;
  text-transform: none;
  padding: 0px;
  border-style: solid;
  border-color: rgb(194, 195, 201);
  border-width: 0px 0px 1px;
  transition: border-bottom-color 100ms cubic-bezier(0.4, 0, 0.2, 1);
}
.PhoneInputInput:focus {
  transition: border-bottom-color 50ms ease border-bottom-width 600ms
    ease-in-out;
  border-width: 0px 0px 2px;
  border-color: rgb(0, 0, 193);
}
.PhoneInputInput:hover {
  border-color: rgb(0, 0, 193);
}
.PhoneInputCountrySelect {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 20px;
  unicode-bidi: isolate;
}
.PhoneInputCountrySelect option {
  font-size: 1rem;
  line-height: 1.5rem;
  text-align: left;
  /* we can't provide border style as \`option\` element render by OS native UI */
  font-weight: 300;
  color: rgb(52, 56, 75);
  white-space: normal;
  background: rgb(255, 255, 255);
}
`, "",{"version":3,"sources":["webpack://./src/pages/UserInfoPage/phoneInput.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,kEAAkE;AACpE;AACA;EACE;eACa;EACb,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,6EAA6E;EAC7E,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":["* {\n  font-family: \"Manulife JH Sans\", Helvetica, Arial, sans-serif;\n}\n.PhoneInputCountry {\n  padding: 10px;\n  padding-left: 0px;\n}\n.PhoneInputInput {\n  font-size: 1rem;\n  position: relative;\n  font-weight: 300;\n  line-height: 3rem;\n  color: rgb(52, 56, 75);\n  background-color: transparent;\n  width: 100%;\n  box-sizing: border-box;\n  border: none;\n  height: 3rem;\n  text-align: left;\n  text-transform: none;\n  padding: 0px;\n  border-style: solid;\n  border-color: rgb(194, 195, 201);\n  border-width: 0px 0px 1px;\n  transition: border-bottom-color 100ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n.PhoneInputInput:focus {\n  transition: border-bottom-color 50ms ease border-bottom-width 600ms\n    ease-in-out;\n  border-width: 0px 0px 2px;\n  border-color: rgb(0, 0, 193);\n}\n.PhoneInputInput:hover {\n  border-color: rgb(0, 0, 193);\n}\n.PhoneInputCountrySelect {\n  display: block;\n  list-style-type: disc;\n  margin-block-start: 1em;\n  margin-block-end: 1em;\n  margin-inline-start: 0px;\n  margin-inline-end: 0px;\n  padding-inline-start: 20px;\n  unicode-bidi: isolate;\n}\n.PhoneInputCountrySelect option {\n  font-size: 1rem;\n  line-height: 1.5rem;\n  text-align: left;\n  /* we can't provide border style as `option` element render by OS native UI */\n  font-weight: 300;\n  color: rgb(52, 56, 75);\n  white-space: normal;\n  background: rgb(255, 255, 255);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
